import React from 'react'
import { signInInternal } from '../../features/auth/authSlice'
import { useSignInForm } from '../../features/auth/useSignInForm'
import NeutralAuthLayout from '../../components/NeutralAuth/NeutralAuthLayout'
import NeutralSignInForm from '../../components/NeutralAuth/NeutralSignInForm'
import { TEAM_PORTAL_LABEL } from '../../lib/portalAudience'
import { GridIcon, ShieldLockIcon, UsersIcon } from '../../components/NeutralAuth/icons'

const FEATURES = [
  { Icon: UsersIcon, title: 'Your Clients', text: 'Contacts, cases and documents in one place.' },
  { Icon: GridIcon, title: 'Your Workspace', text: 'Tasks, payments and reports for your team.' },
  { Icon: ShieldLockIcon, title: 'Secure Access', text: 'Sign in with your staff credentials.' },
]

const goHome = () => {
  window.location.href = '/'
}

const NeutralInternalSignIn = () => {
  const form = useSignInForm({ thunk: signInInternal, defaultRedirect: goHome })

  return (
    <NeutralAuthLayout
      brandLabel={TEAM_PORTAL_LABEL}
      headline={['Welcome back,', 'team.']}
      lede="Sign in with your staff credentials to access the CRM."
      features={FEATURES}
    >
      <NeutralSignInForm
        idPrefix="na-team"
        title="Team Access"
        subtitle="Sign in to your account"
        emailPlaceholder="name@company.com"
        forgotHref="/forgot-password/internal"
        submitLabel="Sign In"
        form={form}
      />
    </NeutralAuthLayout>
  )
}

export default NeutralInternalSignIn
